// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.twocolumns[data-v-6d10f463] {\r\n  -webkit-column-count: 2;\r\n     -moz-column-count: 2;\r\n          column-count: 2;\n}\r\n\r\n", ""]);
// Exports
module.exports = exports;
